<template>
    <div class="header  animate__animated animate__fadeIn" id="header ">
        <div class="header_con">
            <div class="logo_img" @click="logoClick">
              <img id="header-img" src="../../assets/dinghan-logo.png" >
            </div>
            <div class="menu_index" id="menu_index"  >
                

            </div>
            <div class="opera">
                <span class="opera-close" @click="closeWindow">关闭</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "header",
        data() {
            return {
                
            };
        },
        components:{
         
        },
       
        computed: {
           

        },
        methods: {
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            },
            closeWindow(){
                window.close();
            },
           
        },
      
    }
</script>

<style scoped>
.header {
  width: 100%;
  height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 65px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.header_con {
  max-width: 1040px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
}

.logo_img {
  width: 160px;
  cursor: pointer;
  display: flex;
  justify-content:flex-start;
  align-items: center;
}

.logo_img img {
  width: 85%;
}

.menu_index {
  font-size: 18px;
  display: flex;
}

.header_con .opera {
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: auto;
}

.opera-close {
  cursor: pointer;
  color:#666;
  font-size: 15px;
  margin-right: 5px;
}
.opera-close:hover{
  color:#333;
}
@media screen and (max-device-width: 415px) {
  .logo_img {
    float: left;
    width: 10em;
    cursor: pointer;
    padding: 0 20px;
  }

  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }
}
</style>
